// src/ProtectedRoute.js
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext'; //

function ProtectedRoute() {
  // ดึงสถานะ Login และสถานะ "กำลังโหลด" มาจาก Context
  const { isAuthenticated, loading } = useAuth(); //

  // (สำคัญ) ถ้าระบบกำลังตรวจสอบ Token... ให้รอ
  if (loading) {
    return <div>Loading...</div>; 
  }

  // (เงื่อนไขที่ 1) ถ้า "ไม่ได้" Login
  if (!isAuthenticated) {
    // ส่งไปหน้า Login
    return <Navigate to="/login" replace />; //
  }

  // (เงื่อนไขที่ 2) ถ้า Login แล้ว
  return <Outlet />; // (อนุญาตให้แสดงหน้าลูก (เช่น Dashboard))
}

export default ProtectedRoute;